import { render } from "./InstructorPage.vue?vue&type=template&id=8748cebe&scoped=true"
import script from "./InstructorPage.vue?vue&type=script&lang=js"
export * from "./InstructorPage.vue?vue&type=script&lang=js"

import "./InstructorPage.vue?vue&type=style&index=0&id=8748cebe&lang=sass&scoped=true"
import "./InstructorPage.vue?vue&type=style&index=1&id=8748cebe&lang=sass"

import exportComponent from "../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8748cebe"]])

export default __exports__